<template>
  <div class="mb-4">
    <ol class="stepper">
      <li
        class="stepper-item"
        v-for="(step,index) in steps"
        :key="index"
        :class="{ active: activeStep - 1 === index, done: activeStep - 1 > index }"></li>
    </ol>
  </div>
</template>

<script>
  export default {
    name: 'Stepper',
    props: [ 'activeStep'],
    data() {
      return {
        steps: [1,2,3,4,5]
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../scss/mixins';

  .stepper {
    display: flex;
    align-items: center;
    justify-content: center;
    counter-reset: custom-counter;
    max-width: 780px;
    margin-right: auto;
    margin-left: auto;

    li {
      counter-increment: custom-counter;
      width: 20%;
      position: relative;
      &:last-child::after {
        content: none;
      }
      &::before {
        background: var(--color-light);
        content: counter(custom-counter);
        display: flex;
        align-items: center;
        justify-content: center;
        border-width: 2px;
        border-style: solid;
        border-color: var(--color-gray);
        border-radius: 50%;
        color: var(--color-gray);
        font-family: var(--font-marat);
        margin: auto;

        $size: 40px;
        width: $size;
        height: $size;
        font-size: var(--font-24);
        @include respond-to('desktop') {
          $size: 46px;
          width: $size;
          height: $size;
          font-size: var(--font-32);
        }
      }
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: var(--color-gray);
        font-variant: lining-nums;
        top: 50%;
        left: 50%;
        z-index: -1;
      }
      &.done {
        &::before {
          background-color: var(--color-pink);
          color: var(--color-white);
          border-color: var(--color-pink);
        }
        &::after {
          background-color: var(--color-pink);
        }
      }
      &.active {
        &::before {
          background-color: var(--color-white);
          color: var(--color-pink);
          border-color: var(--color-pink);
        }
      }
    }
  }
</style>
